<template>
  <div class="about-main slide-item">
    <div class="slide-content">
      <div class="title">
        公司简介
        <div class="line"></div>
      </div>

      <div class="about-item">
        <img class="bg-img animated backInLeft" src="/image/image/about.jpg" alt="">
        <div class="about-desc animated backInRight">
          <div class="a-d-item">
            <div class="a-d-title">公司简介</div>
            <div class="a-d-contect">山东昱晟玻璃制品有限公司是一家国内玻璃瓶生产企业；口服液瓶、药用玻璃瓶、抗生素瓶、安瓿瓶、管制西林瓶、管制螺口滴管瓶、硼硅奶瓶、方瓶，滚珠瓶，香水瓶，化妆品瓶、甲油瓶等等。 盖子系列；口服液铝盖、医用铝塑盖 、黑白塑料盖、医用级硅胶垫片、电化铝盖、胶头、滴管、内塞、等 。 我们可以为您提供磨砂、丝印、烫金、烫银、电镀、喷涂等工艺后加工。我们将以最优质的产品和完善的服务，热烈欢迎各界朋友光临指导和业务洽谈；“以人为本，靠技术进步”是公司发展的战略方针。已更新的设计理念不断创新，引进电脑化管理系统，向现代化企业迈进，是自己的产品日趋完善；卓越的品质，完美的追求，是公司的一贯质量宗旨；质量是企业的生命，公司始终坚持“以质量取胜，信誉为本”的原则。 公司已近两百种产品畅销全国并出口各个国家和地区，深得了国内外诸多知名企业的信赖；结成与国内外商家双赢合作，共同发展，共创辉煌。</div>
          </div>
          <!-- <div class="a-d-line"></div>
          <div class="a-d-item">
            <div class="a-d-title">公司主营</div>
            <div class="a-d-contect">陶瓷纤维系列产品：包括棉、毯、模块、板、纸、毡、异形件。可溶性纤维系列产品：包括棉、毯、模块、板、纸、毡、异形件。纳米微孔板、纤维表面涂料、纤维灌浆料等其它特殊材料。广泛应用于石油、化工、电力、冶金、消防、建材、机械、造船、航天等行业。并根据客户需要配套其它关联厂家的产品，对客户提供一站式服务。</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style scoped>
</style>